const NoDataSvg = () => {
  return (
    <svg
      width="124"
      height="108"
      viewBox="0 0 124 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10.5"
        y="0.5"
        width="102"
        height="106"
        rx="5.5"
        stroke="#525252"
      />
      <path
        d="M10.5779 6.16476C10.5779 3.07925 13.0792 0.577946 16.1648 0.577946H106.835C109.921 0.577946 112.422 3.07925 112.422 6.16476V12.9176C112.422 14.3008 111.301 15.4221 109.918 15.4221H10.5779V6.16476Z"
        fill="#525252"
        stroke="#525252"
        strokeWidth="1.15589"
      />
      <path
        d="M18 10.0038C19.1046 10.0038 20 9.10751 20 8.00189C20 6.89628 19.1046 6 18 6C16.8954 6 16 6.89628 16 8.00189C16 9.10751 16.8954 10.0038 18 10.0038Z"
        fill="white"
      />
      <path
        d="M26 10.0038C27.1046 10.0038 28 9.10751 28 8.00189C28 6.89628 27.1046 6 26 6C24.8954 6 24 6.89628 24 8.00189C24 9.10751 24.8954 10.0038 26 10.0038Z"
        fill="white"
      />
      <path
        d="M36 8.00189C36 9.10751 35.1046 10.0038 34 10.0038C32.8954 10.0038 32 9.10751 32 8.00189C32 6.89628 32.8954 6 34 6C35.1046 6 36 6.89628 36 8.00189Z"
        fill="white"
      />
      <g clipPath="url(#clip0_1361_25661)">
        <path
          d="M66.1396 78C62.7488 78 60 75.2482 60 71.8538C60 68.4594 62.7488 65.7077 66.1396 65.7077C66.6675 65.7077 67.1798 65.7743 67.6686 65.8998C68.4598 64.5343 69.9359 63.616 71.6263 63.616C72.1018 63.616 72.5604 63.6887 72.9915 63.8235C74.084 62.1249 75.9895 61 78.1576 61C81.5484 61 84.2972 63.7517 84.2972 67.1462C84.2972 67.5342 84.2613 67.9137 84.1926 68.2818C86.8499 68.2957 89 70.547 89 73.322V77.069C89 77.5784 88.5874 77.9903 88.0786 77.9903L66.1396 78Z"
          fill="white"
        />
        <path
          d="M60.007 70C61.5345 72.6286 63.1426 74.9996 67.0303 75C75.0767 75.0003 88 75 88 75V77.9877L67.0303 78C63.1475 77.9999 60 74.5728 60 70.3452C60 70.2295 60.0024 70.1144 60.007 70Z"
          fill="#EBEBEB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.6686 65.8998C67.1798 65.7743 66.6675 65.7077 66.1396 65.7077C62.7488 65.7077 60 68.4594 60 71.8538C60 75.2482 62.7488 78 66.1396 78L88.0786 77.9903C88.5874 77.9903 89 77.5784 89 77.069V73.322C89 70.9036 87.3671 68.883 85.1885 68.3944C84.8672 68.3223 84.5341 68.2836 84.1926 68.2818C84.2532 67.9572 84.2883 67.6236 84.2957 67.2831C84.2967 67.2376 84.2972 67.1919 84.2972 67.1462C84.2972 63.7517 81.5484 61 78.1576 61C75.9895 61 74.084 62.1249 72.9915 63.8235C72.5604 63.6887 72.1018 63.616 71.6263 63.616C69.9359 63.616 68.4598 64.5343 67.6686 65.8998ZM66.1396 77L88 76.9903V73.322C88 71.0576 86.2557 69.2926 84.1874 69.2818L82.9899 69.2755L83.2096 68.0984C83.267 67.7905 83.2972 67.4723 83.2972 67.1462C83.2972 64.303 80.9951 62 78.1576 62C76.3442 62 74.749 62.9396 73.8326 64.3645L73.4204 65.0055L72.693 64.7779C72.3574 64.6729 71.9994 64.616 71.6263 64.616C70.3074 64.616 69.1538 65.3313 68.5339 66.4011L68.154 67.0567L67.4201 66.8684C67.0118 66.7636 66.583 66.7077 66.1396 66.7077C63.3021 66.7077 61 69.0107 61 71.8538C61 74.6968 63.3018 76.9997 66.1391 77C66.1393 77 66.1394 77 66.1396 77Z"
          fill="#525252"
        />
      </g>
      <g clipPath="url(#clip1_1361_25661)">
        <path
          d="M49.8604 43C53.2512 43 56 40.2482 56 36.8538C56 33.4594 53.2512 30.7077 49.8604 30.7077C49.3325 30.7077 48.8202 30.7743 48.3314 30.8998C47.5402 29.5343 46.0641 28.616 44.3737 28.616C43.8982 28.616 43.4396 28.6887 43.0085 28.8235C41.916 27.1249 40.0105 26 37.8424 26C34.4516 26 31.7028 28.7517 31.7028 32.1462C31.7028 32.5342 31.7387 32.9137 31.8074 33.2818C29.1501 33.2957 27 35.547 27 38.322V42.069C27 42.5784 27.4126 42.9903 27.9214 42.9903L49.8604 43Z"
          fill="white"
        />
        <path
          d="M55.993 35C54.4655 37.6286 52.8574 39.9996 48.9697 40C40.9233 40.0003 28 40 28 40V42.9877L48.9697 43C52.8525 42.9999 56 39.5728 56 35.3452C56 35.2295 55.9976 35.1144 55.993 35Z"
          fill="#EBEBEB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.3314 30.8998C48.8202 30.7743 49.3325 30.7077 49.8604 30.7077C53.2512 30.7077 56 33.4594 56 36.8538C56 40.2482 53.2512 43 49.8604 43L27.9214 42.9903C27.4126 42.9903 27 42.5784 27 42.069V38.322C27 35.9036 28.6329 33.883 30.8115 33.3944C31.1328 33.3223 31.4659 33.2836 31.8074 33.2818C31.7468 32.9572 31.7117 32.6236 31.7043 32.2831C31.7033 32.2376 31.7028 32.1919 31.7028 32.1462C31.7028 28.7517 34.4516 26 37.8424 26C40.0105 26 41.916 27.1249 43.0085 28.8235C43.4396 28.6887 43.8982 28.616 44.3737 28.616C46.0641 28.616 47.5402 29.5343 48.3314 30.8998ZM49.8604 42L28 41.9903V38.322C28 36.0576 29.7443 34.2926 31.8126 34.2818L33.0101 34.2755L32.7904 33.0984C32.733 32.7905 32.7028 32.4723 32.7028 32.1462C32.7028 29.303 35.0049 27 37.8424 27C39.6558 27 41.251 27.9396 42.1674 29.3645L42.5796 30.0055L43.307 29.7779C43.6426 29.6729 44.0006 29.616 44.3737 29.616C45.6926 29.616 46.8462 30.3313 47.4661 31.4011L47.846 32.0567L48.5799 31.8684C48.9882 31.7636 49.417 31.7077 49.8604 31.7077C52.6979 31.7077 55 34.0107 55 36.8538C55 39.6968 52.6982 41.9997 49.8609 42C49.8607 42 49.8606 42 49.8604 42Z"
          fill="#525252"
        />
      </g>
      <g clipPath="url(#clip2_1361_25661)">
        <path
          d="M10 55L29.1293 55C33.7704 54.7205 38 50.937 38 46.3313C38 41.7985 34.4401 38.0783 29.9034 37.6951C28.3951 36.0095 26.2057 34.9208 23.7547 34.839C21.9408 33.0839 19.4456 32 16.6913 32C14.1208 32 11.776 32.944 10 34.4967V55Z"
          fill="white"
        />
        <path
          d="M37.4265 43.2598C36.3272 47.3984 32.5672 50.447 28.0979 50.447L10.9575 50.4476L10.9575 54.4998H29.2081C33.9279 54.4995 37.754 51.2776 37.754 45.926C37.754 45.0013 37.6398 44.1068 37.4265 43.2598Z"
          fill="#EBEBEB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.4232 38.6581L29.1582 38.3619C27.8272 36.8745 25.8927 35.9109 23.7214 35.8385L23.3363 35.8256L23.0594 35.5577C21.4268 33.978 19.179 33 16.6913 33C14.5313 33 12.5525 33.7372 11 34.9652V54L29.0983 54C33.3037 53.732 37 50.3004 37 46.3313C37 42.3416 33.8617 39.033 29.8192 38.6915L29.4232 38.6581ZM29.1293 55L10 55V34.4967C11.776 32.944 14.1208 32 16.6913 32C19.4456 32 21.9408 33.0839 23.7547 34.839C26.2057 34.9208 28.3951 36.0095 29.9034 37.6951C34.4401 38.0783 38 41.7985 38 46.3313C38 50.937 33.7704 54.7205 29.1293 55Z"
          fill="#525252"
        />
      </g>
      <g clipPath="url(#clip3_1361_25661)">
        <path
          d="M113 96L86.357 96C79.8919 95.599 74 90.1705 74 83.5622C74 77.0588 78.959 71.7211 85.2787 71.1712C87.3798 68.7528 90.4297 67.1908 93.8438 67.0734C96.3706 64.5552 99.8465 63 103.683 63C107.262 63 110.527 64.3529 113 66.5784V96Z"
          fill="white"
        />
        <g style={{ mixBlendMode: "darken" }}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M76.2152 77C76.2137 77.0828 76.2129 77.166 76.2129 77.2493C76.2129 77.2493 73.9458 90.2809 89 91H112V96H89C82.8294 95.5251 74.5 91.9674 74.5 84.5C74.5 81.9099 74.5116 79.0563 76.2152 77Z"
            fill="#EBEBEB"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.2787 71.1712C78.959 71.7211 74 77.0588 74 83.5622C74 90.1705 79.8919 95.599 86.357 96L113 96V66.5784C110.527 64.3529 107.262 63 103.683 63C99.8465 63 96.3706 64.5552 93.8438 67.0734C90.4297 67.1908 87.3798 68.7528 85.2787 71.1712ZM112 67.0337C109.746 65.1386 106.847 64 103.683 64C100.123 64 96.8974 65.442 94.5497 67.7817L94.2712 68.0593L93.8782 68.0728C90.7537 68.1802 87.9608 69.6088 86.0336 71.827L85.7683 72.1324L85.3654 72.1674C79.5633 72.6723 75 77.5766 75 83.5622C75 89.5578 80.3854 94.6118 86.3887 95L112 95V67.0337Z"
          fill="#525252"
        />
      </g>
      <g clipPath="url(#clip4_1361_25661)">
        <path
          d="M37.838 94C43.4503 93.9999 48 89.4677 48 83.8769C48 78.2861 43.4502 73.7538 37.8378 73.7538C36.9641 73.7538 36.1162 73.8636 35.3071 74.0702C33.9976 71.8212 31.5543 70.3087 28.7565 70.3087C27.9694 70.3087 27.2104 70.4284 26.4968 70.6505C24.6886 67.8528 21.5346 66 17.9461 66C12.3337 66 7.78394 70.5323 7.78394 76.1231C7.78394 76.7621 7.84338 77.3874 7.95706 77.9935C3.55871 78.0165 0 81.7244 0 86.2951V92.4667C0 93.3056 0.682859 93.9839 1.52503 93.9839L37.838 94Z"
          fill="white"
        />
        <path
          d="M1.52547 92.9839L37.838 92.9999C42.9014 92.9996 47 88.9116 47 83.8768C47 81.7528 46.2706 79.7973 45.0471 78.2461C45.3198 79.8136 46.3141 88.4954 35 89.0041H1V92.4666C1 92.748 1.23034 92.9839 1.52547 92.9839Z"
          fill="#EBEBEB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.3071 74.0702C36.1162 73.8636 36.9641 73.7538 37.8378 73.7538C43.4502 73.7538 48 78.2861 48 83.8769C48 89.4677 43.4503 93.9999 37.838 94L1.52503 93.9839C0.682858 93.9839 0 93.3056 0 92.4667V86.2951C0 82.0777 3.0298 78.5949 6.95339 78.0636C7.28209 78.0191 7.61707 77.9953 7.95706 77.9935C7.89565 77.666 7.85006 77.333 7.82113 76.9952C7.7965 76.7078 7.78394 76.4169 7.78394 76.1231C7.78394 70.5323 12.3337 66 17.9461 66C21.5346 66 24.6886 67.8528 26.4968 70.6505C27.2104 70.4284 27.9694 70.3087 28.7565 70.3087C31.5543 70.3087 33.9976 71.8212 35.3071 74.0702ZM37.838 93L1.52547 92.9839C1.23034 92.9839 1 92.7481 1 92.4667V86.2951C1 82.2398 4.14841 79.0134 7.96227 78.9935L9.16084 78.9873L8.93993 77.8092C8.83759 77.2635 8.78394 76.7 8.78394 76.1231C8.78394 71.0882 12.8823 67 17.9461 67C21.1822 67 24.0258 68.6696 25.6569 71.1933L26.069 71.831L26.794 71.6053C27.4124 71.4128 28.0713 71.3087 28.7565 71.3087C31.1852 71.3087 33.3058 72.6205 34.443 74.5734L34.8229 75.2259L35.5545 75.0391C36.2834 74.853 37.0482 74.7538 37.8378 74.7538C42.9016 74.7538 47 78.842 47 83.8769C47 88.9116 42.9014 92.9997 37.838 93Z"
          fill="#525252"
        />
      </g>
      <g clipPath="url(#clip5_1361_25661)">
        <path
          d="M85.162 38C79.5497 37.9999 75 33.4677 75 27.8769C75 22.2861 79.5497 17.7538 85.1622 17.7538C86.0359 17.7538 86.8838 17.8636 87.6929 18.0702C89.0024 15.8212 91.4457 14.3087 94.2435 14.3087C95.0306 14.3087 95.7896 14.4284 96.5032 14.6505C98.3114 11.8528 101.465 10 105.054 10C110.666 10 115.216 14.5323 115.216 20.1231C115.216 20.7621 115.157 21.3874 115.043 21.9935C119.441 22.0165 123 25.7244 123 30.2951V36.4667C123 37.3056 122.317 37.9839 121.475 37.9839L85.162 38Z"
          fill="white"
        />
        <path
          d="M121.475 36.9839L85.162 36.9999C80.0986 36.9996 76 32.9116 76 27.8768C76 25.7528 76.7294 23.7973 77.9529 22.2461C77.6802 23.8136 76.6859 32.4954 88 33.0041H122V36.4666C122 36.748 121.77 36.9839 121.475 36.9839Z"
          fill="#EBEBEB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.6929 18.0702C86.8838 17.8636 86.0359 17.7538 85.1622 17.7538C79.5497 17.7538 75 22.2861 75 27.8769C75 33.4677 79.5497 37.9999 85.162 38L121.475 37.9839C122.317 37.9839 123 37.3056 123 36.4667V30.2951C123 26.0777 119.97 22.5949 116.047 22.0636C115.718 22.0191 115.383 21.9953 115.043 21.9935C115.104 21.666 115.15 21.333 115.179 20.9952C115.203 20.7078 115.216 20.4169 115.216 20.1231C115.216 14.5323 110.666 10 105.054 10C101.465 10 98.3114 11.8528 96.5032 14.6505C95.7896 14.4284 95.0306 14.3087 94.2435 14.3087C91.4457 14.3087 89.0024 15.8212 87.6929 18.0702ZM85.162 37L121.475 36.9839C121.77 36.9839 122 36.7481 122 36.4667V30.2951C122 26.2398 118.852 23.0134 115.038 22.9935L113.839 22.9873L114.06 21.8092C114.162 21.2635 114.216 20.7 114.216 20.1231C114.216 15.0882 110.118 11 105.054 11C101.818 11 98.9742 12.6696 97.3431 15.1933L96.931 15.831L96.206 15.6053C95.5876 15.4128 94.9287 15.3087 94.2435 15.3087C91.8148 15.3087 89.6942 16.6205 88.557 18.5734L88.1771 19.2259L87.4455 19.0391C86.7166 18.853 85.9518 18.7538 85.1622 18.7538C80.0984 18.7538 76 22.842 76 27.8769C76 32.9116 80.0986 36.9997 85.162 37C85.1622 37 85.1619 37 85.162 37Z"
          fill="#525252"
        />
      </g>
      <defs>
        <clipPath id="clip0_1361_25661">
          <rect
            width="29"
            height="17"
            fill="white"
            transform="translate(60 61)"
          />
        </clipPath>
        <clipPath id="clip1_1361_25661">
          <rect
            width="29"
            height="17"
            fill="white"
            transform="matrix(-1 0 0 1 56 26)"
          />
        </clipPath>
        <clipPath id="clip2_1361_25661">
          <rect
            width="28"
            height="23"
            fill="white"
            transform="translate(10 32)"
          />
        </clipPath>
        <clipPath id="clip3_1361_25661">
          <rect
            width="39"
            height="33"
            fill="white"
            transform="translate(74 63)"
          />
        </clipPath>
        <clipPath id="clip4_1361_25661">
          <rect
            width="48"
            height="28"
            fill="white"
            transform="translate(0 66)"
          />
        </clipPath>
        <clipPath id="clip5_1361_25661">
          <rect
            width="48"
            height="28"
            fill="white"
            transform="translate(75 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoDataSvg;
